import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import HouseWindow from './HouseWindow';
import SoundAssetKeys from '../SoundAssetKeys';

export default class House extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.isNighttime = null;

    const windowInfo = [
      { x: 37,y: 197,width: 19,height: 42 },
      { x: 91,y: 194,width: 18,height: 36 },
      { x: 120,y: 110,width: 21,height: 33 },
      { x: 169,y: 91,width: 19,height: 43 },
      { x: 206,y: 93,width: 17,height: 42 },
      { x: 190,y: 64,width: 10,height: 10 }
    ];

    this.windows = [];
    let win = null;
    for (let i = 0; i < windowInfo.length; i++) {
      win = new HouseWindow(this.scene, windowInfo[i].width, windowInfo[i].height);
      this.windows.push(win);
      win.x = windowInfo[i].x;
      win.y = windowInfo[i].y;
      this.add(win);
    }

    this.baseHouse = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._House, this).setOrigin(0)
      .setInteractive({ pixelPerfect: true })
      .on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.houseClick, this);

    this.houseSound = ABCyaPhaser.Audio.createSound(this.scene);
  }

  houseClick () {
    if (!this.isNighttime) return;
    const r = Phaser.Math.Between(1,100);
    let snd = '';
    if (r < 40) {
      snd = SoundAssetKeys._scary_cat;
    }
    else {
      snd = SoundAssetKeys._door_squeak_cut;
    }
    this.houseSound.stop();
    ABCyaPhaser.Audio.playSound(snd, this.houseSound);
  }

  switchTime (isnight) {
    this.isNighttime = isnight;
    if (this.isNighttime) {
      this.turnLightsOn();
    }
    else {
      this.turnLightsOff();
    }
  }

  turnLightsOn () {
    const len = this.windows.length;
    for (let i = 0; i < len; i++) {
      this.windows[i].turnLightOn();
    }
  }

  turnLightsOff () {
    const len = this.windows.length;
    for (let i = 0; i < len; i++) {
      this.windows[i].stopAnimations();
      this.windows[i].turnLightOff();
    }
  }

  tick (dt) {
    if (this.isNighttime) {
      const len = this.windows.length;
      for (let i = 0; i < len; i++) {
        this.windows[i].tick(dt);
      }
    }
  }
}